import { SentSMSStatus } from './onboarding.types';

export const SentSMSStatusLabelMap: Record<SentSMSStatus, string> = {
  [SentSMSStatus.STATUS_UNSPECIFIED]: 'Unspecified',
  [SentSMSStatus.STATUS_ERROR]: 'Error',
  [SentSMSStatus.STATUS_SENT]: 'Sent',
  [SentSMSStatus.STATUS_NEW]: 'New',
  [SentSMSStatus.STATUS_DELIVERED]: 'Delivered',
  [SentSMSStatus.STATUS_RECEIVED]: 'Received',
  [SentSMSStatus.STATUS_READ]: 'Read',
  [SentSMSStatus.STATUS_NOT_SENT]: 'Not Sent',
};
